<div *ngIf="isLoading" class="hero-banner-skeleton shimmer"></div>

<div class="position-relative header-margin" [class.hidden]="isLoading">
  <button
  [class.hidden]="!swiperReady"
    class="d-flex align-items-center justify-content-center position-absolute hero-carousel-arrow hero-carousel-arrow-prev"
  >
    <img src="images/prev-arrow.svg" height="14" width="10" alt="prev arrow" />
  </button>
  <div *ngIf="!swiperReady" class="hero-carousel">
    <picture>
      <source media="(max-width: 767px)" [srcset]="predefinedBannerList['mobile']?.imgUrl" />
      <source media="(max-width: 1024px)" [srcset]="predefinedBannerList['tablet']?.imgUrl" />
      <img
        [src]="predefinedBannerList['desktop']?.imgUrl"
        class="w-100 h-100"
        fetchpriority="high"
        alt="banner"
      />
  </picture>
 
</div>

  <div class="hero-carousel-container"  [class.swiper-hidden]="!swiperReady">
    <!-- SSR / Instant paint -->
    <swiper-container
      id="hero-swiper-container"
      init="false"
      #swiperContainerHeroCarousel
    >
      @for (banner of bannerList; track banner; let index = $index){
      <swiper-slide (click)="onBannerClick(index)">
        <ng-container
          *ngTemplateOutlet="
            swiperSlide;
            context: {
              isClickable: bannerList[index].isClickable,
              banners: bannerList[index].imgUrl,
            }
          "
        ></ng-container>
      </swiper-slide>
      }
    </swiper-container>
  </div>

  <button
  [class.hidden]="!swiperReady"
    class="d-flex align-items-center justify-content-center position-absolute hero-carousel-arrow hero-carousel-arrow-next"
  >
    <img width="10" height="14" src="images/next-arrow.svg" alt="Next" />
  </button>

  <ng-template let-banners="banners" let-isClickable="isClickable" #swiperSlide>
    <div
      class="hero-carousel position-relative"
      [ngClass]="{ 'cursor-pointer': isClickable }"
    >
      <!-- Banners -->
      <img
        fetchpriority="high"
        [src]="banners"
        alt="Banners"
        class="w-100 h-100"
      />
    </div>
  </ng-template>

  <div class="hero-swiper-pagination swiper-pagination"></div>
</div>
